import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { getAccountHomePath } from '@/lib/accountRouting';
import type { UserRole } from '@/types/domain';

export function ProtectedRoute() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  return isAuthenticated
    ? <Outlet />
    : <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
}

export function RoleRoute({ roles }: { roles: UserRole[] }) {
  const { user } = useAuth();
  return user && roles.includes(user.userType)
    ? <Outlet />
    : <Navigate to={getAccountHomePath(user?.userType)} replace />;
}
